export enum WhatsAppTemplateCategoryEnum {
  MARKETING = 'marketing',
  UTILITY = 'utility',
  AUTHENTICATION = 'authentication',
}
